<template>
  <div class="dropdown">
    <a-dropdown>
      <a class="name tenant-pill" @click.prevent>
        <img :src="companyIcon" class="tenant-icon" alt="" />
        <span class="tenant-text">{{merchantName}}</span>
        <svg v-if="merchantOptions.length > 1" class="tenant-caret" viewBox="0 0 16 16" fill="none" aria-hidden="true">
          <path d="M4.5 6.25 8 9.75l3.5-3.5" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </a>
      <a-menu slot="overlay">
        <a-menu-item v-for="item in merchantOptions" :key="item.customerId" :value="item.customerId">
          <div @click="switchTenant(item)">{{item.tenantName}}</div>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>
<script>
import { post } from '@/utils/http';
import api from '@/api';
import { message } from 'ant-design-vue';
import {
  setAccount, setToken,
} from '../../views/login/login-handler';
import { getUiFitment } from '@/utils/accessResources';
import mainBus from '@/micro/eventBus';

export default {
  name: 'TenantSwitch',
  created() {
    this.getTenantList();
  },
  data() {
    return {
      merchantName: '',
      merchantOptions: [],
      companyIcon: require('@/assets/images/pageTabCompany.png'),
    };
  },
  mounted() {
    mainBus.$on('systemInterface', () => {
      // eslint-disable-next-line no-unused-expressions
      // this.switchTenant()
      this.merchantOptions.forEach(m => {
        if(m.tenantName === this.merchantName) {
          this.switchTenant(m)
        }
      });
    });
  },
  methods: {
    getTenantList() {
      const appId = localStorage.getItem('appId') || '';
      const userInfo = localStorage.getItem('user_info') || '{}';
      const info = JSON.parse(userInfo);
      this.merchantName = info.tenantName;
      post(api.tenantList, { appId, userId: info.passportId }).then((res) => {
        const webSource = localStorage.getItem('webSource');
        if (webSource === 'dingtalk') {
          const tenantId = localStorage.getItem('tenantId');
          // 钉钉环境下，只显示当前登录的租户
          this.merchantOptions = (res || []).filter((item) => item.tenantId === tenantId);
        } else {
          this.merchantOptions = res;
        }
      });
    },
    switchTenant(val) {
      post(api.switchTenant, { customerId: val.customerId }).then((res) => {
        setToken(res);
        this.getLoginAccount(res);
      });
    },
    // 获取用户信息
    getLoginAccount  (loginRes)  {
      post(api.loginAccount, {}).catch(() => {
        message.error('用户信息查询失败');
      })
        .then((res) => {
          // 之后缓存菜单需要参数
           setAccount(res, loginRes);
           getUiFitment().finally(()=>{
                if (res.id) {
                this.$store.commit('emptyTab');
                this.$router.push('/');
                // eslint-disable-next-line no-restricted-globals
                location.reload();
              }
           })
        });
    },
  },
};
</script>

<style lang="less" scoped>

.dropdown{
  /* 右侧不留内边距：公司名到用户头像间距由 header 的 gap(20px) 决定，避免叠加成 28px */
  padding: 0 0 0 8px;
  /* 公司名胶囊框到头像框收紧为 16px：实测基线约 30px（header gap 20px + 头像盒内留白等约 10px），故负边距取 -14px */
  margin-right: -14px;

  .tenant-pill{
    display: inline-flex;
    align-items: center;
    height: 32px;
    padding: 0 14px;
    border-radius: 1000px;
    background: linear-gradient(90deg, #d3ddf6 -2%, #e8eefa 102%);
    font-size: 14px;
    color: #000000;

    &:hover{
      opacity: 0.85;
    }

    .tenant-icon{
      width: 16px;
      height: 16px;
      margin-right: 6px;
      flex-shrink: 0;
    }

    .tenant-text{
      color: #000000;
    }

    .tenant-caret{
      width: 14px;
      height: 14px;
      flex-shrink: 0;
      color: #000000;
    }
  }
}
</style>
